export const GLOBAL_LOGIN_LABELS = 'global.login';
export const lblLoginCreateAcctHelp = 'lbl_login_createAccountHelp';
export const lblCreateAcntHelp1v1 = 'lbl_login_createAccountHelp_1_v1';
export const lblCreateAcntHelp2v1 = 'lbl_login_createAccountHelp_2_v1';
export const lblEasyShoppingPart1 = 'lbl_login_create_account_easy_shopping_ca_part_1';
export const lblEasyShoppingPart2 = 'lbl_login_create_account_easy_shopping_ca_part_2';
export const lblLoginCreateAcntBtn = 'lbl_login_create_account_button';
export const lblCreateAcnthelp1 = 'lbl_login_createAccountHelp_1';
export const lblCreateAcnthelp2 = 'lbl_login_createAccountHelp_2';
export const lblLoginEnterPwd = 'lbl_enter_pwd';
export const lblLoginForgotPwdCta = 'lbl_login_forgetPasswordCTA';
export const lblLoginSaveMyPlace = 'lbl_login_saveMyPlace';
export const lblLoginRememberMe = 'lbl_login_rememberMe';
export const lblLoginRememberMeTxt = 'lbl_login_rememberMeHelpText';
export const lblLoginTempPwd = 'lbl_login_temp_password';
export const lblLoginCodeMsg = 'lbl_code_msg';
export const lblRequstVerificationBtn = 'lbl_request_verification_btn';
export const lblLoginAndCheckout = 'lbl_login_loginAndCheckout';
export const lblLoginCheckoutAsGuest = 'lbl_login_checkout_as_guest';
export const lblLoginSmsV2Heading = 'lbl_login_sms_v2_heading';
export const lblLoginEmailHeading = 'lbl_login_email_v2_heading';
export const lblLoginPassV2Heading = 'lbl_login_pass_v2_heading';
export const lblLoginSmsV2Subheading2 = 'lbl_login_sms_v2_subheading_2';
export const lblLoginEmailV2SubHeading = 'lbl_login_email_v2_subheading';
export const lblLoginFavoritesModalHeading = 'lbl_login_favorites_modal_heading';
export const lblLoginFavModalHeading1 = 'lbl_login_favorites_modal_heading_1';
export const lblLoginHeading = 'lbl_login_heading';
export const lblLoginSubHeading = 'lbl_login_subHeading';
export const lblLoginDescriptionHeading1 = 'lbl_login_Description_heading_1';
export const lblLoginDescriptionHeading2 = 'lbl_login_Description_heading_2';
export const lblLoginDescriptionClickHere = 'lbl_login_Description_clickhere';
export const lblResetPwdSuccessMsg = 'lbl_reset_pass_succcessMsg';
export const lblLoginSubDescriptionHeading1 = 'lbl_login_subDescription_heading_1';
export const lblLoginBackToBag = 'lbl_login_back_to_bag_label';
export const lblLoginCheckout = 'lbl_login_checkout';
export const lblLoginCheckoutEmail = 'lbl_login_checkout_email';
export const lblLoginV2VerificationCodeSent = 'lbl_login_v2_verification_code_sent';
export const lblLoginVerificationCode = 'lbl_login_verification_code';
export const lblLoginSignInCreateAccount = 'lbl_login_signIn_create_account';
export const lblLoginCreateOrLoginV2 = 'lbl_login_create_or_login_v2';
export const lblLoginContinue = 'lbl_login_Continue';
export const lblLoginEnterEmail = 'lbl_login_enter_email_label';
export const lblLoginErrorModalOk = 'lbl_login_errormodal_ok';
export const lblLoginErrorModalTitle = 'lbl_login_errormodal_title';
export const lblLoginErrorModalMessage = 'lbl_login_errormodal_message';
export const lblLoginNot = 'lbl_login_not';
export const lblLoginDifferentEmail = 'lbl_login_differentEmail';
export const lblLoginv2ChooseLogin = 'lbl_login_v2_choose_login';
export const lblLoginEarnPoint = 'lbl_login_earn_point';
export const lblLoginModalCheckoutAsGuest = 'lbl_login_modal_checkout_as_guest';
export const lblSigninWithPwd = 'lbl_signin_with_pwd';
export const lblSendCodeToMsg = 'lbl_send_code_to_msg';
export const lblLoginV2SigninCreateAcc = 'lbl_login_v2_sign_in_create_acc';
export const lblLoginSubheadingV2 = 'lbl_login_subheading_v2';
export const lblLoginPasswordHint = 'lbl_login_password_hint';
export const lblLoginCheckoutHelloScreenRewards = 'lbl_login_checkout_hello_screen_rewards';
export const lblLoginCheckoutHelloScreenPoints = 'lbl_login_checkout_hello_screen_points';
export const lblLobinCheckoutHelloLabel = 'lbl_login_checkout_hello_label';
export const lblLoginCreateAccountFasterCheckoutCa = 'Create an account for faster checkout';
export const lblLoginOr = 'lbl_login_or';
export const lblLoginCreateAccountBannerTitle2 = 'lbl_login_create_account_banner_title_2';
export const lblLoginCreateAccountBannerTitle3 = 'lbl_login_create_account_banner_title_3';
export const lblLoginCreateAccount = 'lbl_login_create_account_earn_points';
export const lblEveryPurchase = 'lbl_login_every_purchase';
export const lblSmsOptContent = 'lbl_otp_sms_consent';
export const lblShopEarnMore = 'lbl_shop_earn_save';
export const lblCreateAcntBannerTitle4 = 'lbl_login_create_account_banner_title_4';
export const lblCreateAcntBannerTitle5Ca = 'lbl_login_create_account_banner_title_5_ca';
export const lblLoginShopBrandCa = 'lbl_login_shop_brands_ca';
export const lblLoginShopExclusiveCa = 'lbl_login_shop_exclusive_ca';
export const lblPersonalExperience = 'lbl_personal_experience';
export const lblLoginHelloScreenEarnRewards = 'lbl_login_checkout_hello_screen_earn_rewards';
export const lblLoginHelloScreenEarnPoints = 'lbl_login_checkout_hello_screen_earn_points';
export const lblLoginWelcomeScreenTitle = 'lbl_login_welcome_screen_title';
export const lblGuestFavLoginWishlistAddStyle = 'lbl_guestFavLogin_wishlist_add_style';
export const lblInvalidEmail = 'lbl_login_error__ERR_INVALID_EMAIL';
export const lblLoginOrCheckoutGuest = 'lbl_login_or_checkout_guest_label';
export const lblLoginOrCheckoutGuestSubHeading = 'lbl_login_or_checkout_guest_label_sub_heading';
export const lblLoginHide = 'lbl_login_hide';
export const lblLoginShow = 'lbl_login_show';
export const lblInvalidVerifiedEmail = 'lbl_invalid_verified_email';
export const lblEnterValidEmail = 'lbl_enter_valid_email';

export const GlobalLoginLabels = {
  global: {
    login: {
      [lblLoginCreateAcctHelp]: "Don't have an account? Create one now to start earning points!",
      [lblCreateAcntHelp1v1]: "Don't have an account?",
      [lblCreateAcntHelp2v1]: 'Create one now to start earning points!',
      [lblEasyShoppingPart1]: 'Easy Shopping, Faster Checkout',
      [lblEasyShoppingPart2]: 'Create a My Place account today!',
      [lblLoginCreateAcntBtn]: 'CREATE ACCOUNT & CHECKOUT',
      [lblCreateAcnthelp1]: "Don't have an account? Create one now to",
      [lblCreateAcnthelp2]: ' start earning points!',
      [lblLoginEnterPwd]: 'Enter Password',
      [lblLoginForgotPwdCta]: 'Forgot password?',
      [lblLoginSaveMyPlace]:
        'Save My Place Rewards Credit Card ending in #number to my account for future purchases.',
      [lblLoginRememberMe]: 'Remember me',
      [lblLoginRememberMeTxt]: '(Not recommended on shared devices.)',
      [lblLoginTempPwd]: 'Log in with temporary passcode',
      [lblLoginCodeMsg]: 'Code will be sent to',
      [lblRequstVerificationBtn]: 'SEND PASSCODE',
      [lblLoginAndCheckout]: 'LOG IN & CHECKOUT',
      [lblLoginCheckoutAsGuest]: 'CHECKOUT AS GUEST',
      [lblLoginSmsV2Heading]: 'Log in with text code',
      [lblLoginEmailHeading]: 'Log in with email code',
      [lblLoginPassV2Heading]: 'Log in with Password',
      [lblLoginSmsV2Subheading2]: 'Standard messaging rates will apply',
      [lblLoginEmailV2SubHeading]: 'Send to',
      [lblLoginFavoritesModalHeading]: 'Love it. Save it. Share it!',
      [lblLoginFavModalHeading1]: 'Log in or create an account to view your Favorites list.',
      [lblLoginSubHeading]: 'Log in to earn points every time you shop!',
      [lblLoginDescriptionHeading1]: 'Signed up in store?',
      [lblLoginDescriptionHeading2]: 'An online account has been created with your email.',
      [lblLoginDescriptionClickHere]: 'Reset your password.',
      [lblResetPwdSuccessMsg]:
        ' Your password has been successfully updated. Log In using your new password below',
      [lblLoginSubDescriptionHeading1]: 'Signed up in store?',
      [lblLoginCheckout]: 'Checkout',
      [lblLoginBackToBag]: 'Back to Bag',
      [lblLoginCheckoutEmail]: 'Enter your email address to checkout',
      [lblLoginVerificationCode]: 'CODE SENT TO',
      [lblLoginV2VerificationCodeSent]: 'Verification Code Sent',
      [lblLoginSignInCreateAccount]: 'Enter your email address to log in or create an account',
      [lblLoginCreateOrLoginV2]: 'Log In or Create Account',
      [lblLoginContinue]: 'Continue',
      [lblLoginEnterEmail]: 'Enter your email address to checkout',
      [lblLoginErrorModalOk]: 'YES',
      [lblLoginErrorModalTitle]: 'We’re having trouble logging you into the app.',
      [lblLoginErrorModalMessage]: 'Want to shop on our mobile web experience instead?',
      [lblLoginNot]: 'Not',
      [lblLoginDifferentEmail]: 'Use a Different Email',
      [lblLoginv2ChooseLogin]: 'Choose how to login',
      [lblLoginEarnPoint]: 'Log in to earn points on every purchase with',
      [lblLoginModalCheckoutAsGuest]: 'CONTINUE AS GUEST',
      [lblSigninWithPwd]: 'OR log in with your password',
      [lblSendCodeToMsg]: 'Send code to',
      [lblLoginV2SigninCreateAcc]: 'Sign In or Create Account',
      [lblLoginSubheadingV2]:
        'Enter your email address to earn points every time you shop and checkout faster',
      [lblLoginPasswordHint]: 'Log In with password',
      [lblLoginCheckoutHelloScreenRewards]: 'You can earn #rewards reward on this purchase',
      [lblLoginCheckoutHelloScreenPoints]: 'You can earn #points points on this purchase',
      [lblLobinCheckoutHelloLabel]: 'Hello!',
      [lblLoginCreateAccountFasterCheckoutCa]: 'Create an account for faster checkout',
      [lblLoginOr]: 'OR',
      [lblLoginCreateAccountBannerTitle2]: 'Faster future purchase',
      [lblLoginCreateAccountBannerTitle3]: 'Personalized experiences and more!',
      [lblLoginCreateAccount]: 'Earn points every time you shop – ',
      [lblEveryPurchase]: '4 brands, 1 rewarding place!',
      [lblSmsOptContent]: 'By selecting this, you agree standard text messaging rates will apply',
      [lblShopEarnMore]: 'Members get rewarded every step of the way!',
      [lblCreateAcntBannerTitle4]: 'Instant access to rewards, coupons & preferred payments',
      [lblCreateAcntBannerTitle5Ca]: 'Instant access to coupons & preferred payments',
      [lblLoginShopBrandCa]: 'Shop all our brands & check out even faster with an online account.',
      [lblLoginShopExclusiveCa]: 'Be the first to shop new arrivals',
      [lblPersonalExperience]: 'Personalize your shopping experience',
      [lblLoginHelloScreenEarnRewards]: 'Earn #rewards reward on this purchase',
      [lblLoginHelloScreenEarnPoints]: 'Earn #points points on this purchase',
      [lblLoginWelcomeScreenTitle]: 'Log in to shop all our brands & check out even faster',
      [lblGuestFavLoginWishlistAddStyle]: 'wishlists, add styles and more.',
      [lblInvalidEmail]: 'Please enter a valid email',
      [lblLoginHide]: 'Hide',
      [lblLoginShow]: 'Show',
      [lblEnterValidEmail]: 'Please enter a valid email address.',
      [lblInvalidVerifiedEmail]: 'Sorry, there was an issue. Please login instead to checkout.',
      lbl_login_error: 'An error occurred!',
      'lbl_login_error_.2030': 'The email address or password you provided is invalid.',
      'lbl_login_error_.2110':
        'Your account has been locked. Please <a href="JavaScript:void(0)" onclick="document.getElementById(\'forgotPasswordForm\').click()">Reset your password</a>.',
      'lbl_login_error_.EMAIL_VERIFICATION_EXPIRED':
        'Sorry, your verification has expired. Please re-enter your email address to try again.',
      'lbl_login_error_.EMPTY_RECAPTCHA': 'Please check the recaptcha value.',
      'lbl_login_error_.ERR_PASSWORD_EXPIRED':
        'Your current password has expired. Reset it with the Forgot Password link.',
      'lbl_login_error_.INVALID_OTP':
        "Invalid passcode. Check the spelling and try again, or click 'Resend it' for a new passcode.",
      'lbl_login_error_.INVALID_RECAPTCHA': 'Please re-check the recaptcha value.',
      'lbl_login_error_.MULTIPLE_OTP_ATTEMPT':
        'Your account has been locked. Continue as a guest or log in after #lockTime minutes.',
      lbl_login_error__ERR_ACCOUNT_EXISTS_IN_SESSION:
        'Please login to verify your recently created account #emailValue#. If you are unable to verify this account, you may create a new account by clearing your browsers cookies or by using a different browser or device.',
      'lbl_login_error_.OTP_COUNT_EXCEED':
        'Too many passcode attempts. <a href="JavaScript:void(0)" onclick="document.getElementById(\'signWithPwd\').click()">Log in with password</a> instead.',
      lbl_login_error_LOGIN_OTP_EXPIRED: 'Passcode expired. Select “Resend it” for a new passcode.',
      lbl_login_error_LOGIN_OTP_NOT_FOUND:
        'Passcode expired. Select “Resend it” for a new passcode.',
      lbl_login_error_USID_ALREADY_BEEN_ASSIGNED: 'Something went wrong... log out & try again.',
      lbl_login_error__ERR_BAD_PARMS:
        "Sorry, we couldn't find an account associated with that email address. Please try again.",
      lbl_login_error__ERR_EMAIL_ID_NOT_FOUND:
        "Sorry, we couldn't find an account associated with that email address. Please try again.",
      'lbl_login_error_app_.2110':
        'Sorry.you’ve entered an incorrect password multiple times.For your security, the account has been locked.Please click here to reset your password.',
      'lbl_login_error_app_.ERR_PASSWORD_EXPIRED':
        'Your current password has expired. Reset it with the Forgot Password link.',
      lbl_login_error_checkout_modal_heading: 'Welcome Back!',
      lbl_login_error_checkout_modal_heading_1: 'Log in to ',
      lbl_login_error_checkout_modal_heading_2: 'MY PLACE.',
      lbl_login_error_favorites_modal_heading: 'Love it. Save it. Share it!',
      lbl_login_error_favorites_modal_heading_1:
        'Log in or create an account to view your Favorites list. ',
      lbl_login_errormodal_message: 'Want to shop on our mobile web experience instead?',
      lbl_login_errormodal_message_ok: 'YES',
      lbl_login_errormodal_ok: 'YES',
      lbl_login_errormodal_title: 'We’re having trouble logging you into the app.',
      lbl_guestFavLogin_dlf: "Don't lose your favorites!",
      lbl_guestFavLogin_lic: 'Log in or create an account to make',
      lbl_guestFavLogin_wishlist_add_style: 'wishlists, add styles and more.',
      lbl_login_or_checkout_guest_label: 'Login or checkout as a guest!',
      lbl_login_or_checkout_guest_label_sub_heading: 'Enter your email to get started.',
    },
  },
};
